<template>
  <div class="reportsList">
    <div class="reportsListConent">
      <div class="date_list">
        <ul>
          <li
            class="date_list_li"
            :class="[item == currentReportTime ? 'active_date' : '']"
            v-for="(item, index) in timeline"
            :key="index"
            @click="changeDate(item)"
          >
            <div>{{ item }}</div>
          </li>
        </ul>
      </div>
      <div class="reports_list">
        <div class="reports_list_current_box">
          <div class="reports_list_language">
            <div
              class="reports_list_language_element"
              :class="[
                currentReportLanguage == item.langCode ? 'activeLanguage' : '',
              ]"
              v-for="(item, index) in languageList"
              :key="index"
              @click="changeLanguage(item)"
            >
              {{ item.langName }}
            </div>
          </div>
          <div class="reports_list_current" v-if="currentData">
            <div class="reports_list_current_text">
              <!-- <span class="p">{{currentData.fileName}}</span> -->
              <div class="reports_list_current_text_con">
                {{ currentData.fileInfo }}
              </div>
            </div>
            <div class="reports_list_current_repotrt">
              <!-- <img src="../../../assets/image/SdgsReports/1.png" alt /> -->
              <div class="reports_list_current_repotrt_img">
                <img :src="`${GLOBAL.imageUrl}${currentData.cover}`" alt />
              </div>

              <div
                class="download"
                :class="[language == 'zh' ? 'zhFamily' : 'enfamily']"
              >
                <div>
                  <a
                    :href="`${GLOBAL.url}sdg-api/sdg/report/download/${currentData.id}`"
                    >{{ $t("Reports.Download") }}</a
                  >
                </div>
                <div>
                  <a
                    :href="`${GLOBAL.url}file${currentData.filePath}`"
                    target="_blank"
                    >{{ $t("Reports.online") }}</a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="other_reports_list">
          <SwiperReports
            ref="child"
            :reportArray="reportArray"
            :currentData="currentData"
          ></SwiperReports>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMixin } from "@/util/mixin";
import bus from "@/bus";
import { initReportList, reportList } from "@/axios/sdgReport.js";
export default {
  mixins: [mapMixin],
  data() {
    return {
      active_language: 1,
      active_date: 1,
      currentReportTime: null,
      currentReportLanguage: "Chinese",
      languageList: [],
      timeline: [],
      reportArray: [],
      currentData: null,
    };
  },
  watch: {
    language() {
      this.getSdgReportList();
    },
  },
  mounted() {
    this.getSdgReportList();
    bus.$on("reportEmit", (res) => {
      this.currentData = res;
    });
  },
  methods: {
    changeLanguage(item) {
      this.currentReportLanguage = item.langCode;
      this.getReportList();
    },
    changeDate(item) {
      this.currentReportTime = item;
      this.getReportList();
    },
    async getSdgReportList() {
      var res = await initReportList();
      this.languageList = res.data.data.languageList;
      console.log(this.languageList);
      this.timeline = res.data.data.reportTimeList;
      this.currentReportTime = res.data.data.reportTimeList.reverse()[0];
      console.log(this.currentReportTime);
      this.getReportList();
    },
    async getReportList() {
      this.reportArray = [];
      var param = {
        language: this.currentReportLanguage,
        reportTime: this.currentReportTime,
      };
      var res = await reportList(param);
      this.reportArray = res.data.data.list;
      this.currentData = this.reportArray[0];
    },
  },
  components: {
    SwiperReports: () =>
      import("@/components/SdgsReports/SwiperReports/SwiperReports.vue"),
  },
};
</script>

<style lang="scss" scoped>
.reportsList {
  margin-top: 10px;
  width: 100%;

  height: 100vh;
  background: rgba(0, 104, 157, 1);
  .reportsListConent {
    display: flex;
    flex-direction: row;
    height: 100%;
    .date_list {
      min-width: 230px;
      background: rgba(25, 72, 106, 1);
      border-left: 12px solid rgba(75, 159, 58, 1);
      ul {
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        // justify-content: center;
        .date_list_li {
          border: none;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          position: relative;
          height: 80px;
          width: 100%;
          color: #fff;
          font-size: 26px;
          transition: ease-in 0.4s;
          div {
            color: #fff;
            z-index: 999;
          }
          &::before {
            position: absolute;
            content: "";
            width: 12px;
            height: 100%;
            background-color: rgba(75, 159, 58, 1);
            left: -12px;
            top: 0;
            z-index: 2;
            transition: ease-in 0.6s;
          }
          &:hover::before {
            z-index: 0;
            width: calc(100% + 12px);
            transition: ease 0.3s;
            background: rgba(75, 159, 58, 1) !important;
          }
        }
        .active_date {
          color: #fff;
          z-index: 111;
          background: rgba(75, 159, 58, 1) !important;
        }
      }
    }
    .reports_list {
      flex: 1;
      padding: 0 20px;
      display: flex;
      flex-direction: column;
      overflow: hidden;
      .reports_list_current_box {
        height: calc(100vh - 220px);
        flex: 1;
        display: flex;
        flex-direction: column;
        .reports_list_language {
          display: flex;
          flex-direction: row;
          margin-bottom: 10px;
          overflow: hidden;
          .reports_list_language_element {
            padding: 8px 24px;
            color: #ccc;
            margin: 0 4px;
            font-size: 16px;
            cursor: pointer;
          }
          .reports_list_language_element:hover {
            background: rgba(25, 72, 106, 1);
            color: #fff;
            border-radius: 4px;
          }
          .activeLanguage {
            background: rgba(25, 72, 106, 1);
            color: #fff;
            border-radius: 4px;
          }
        }
        .reports_list_current {
          height: calc(100% - 50px);
          display: flex;
          flex-direction: row;
          cursor: pointer;
          &:hover .reports_list_current_text {
            opacity: 0.9;
            transition: 0.2s;
          }
          &:hover .reports_list_current_repotrt_img::after {
            z-index: 33 !important;
            opacity: 0.3 !important;
            transition-timing-function: cubic-bezier(0.23, 1, 0.32, 1);
          }
          &:hover .reports_list_current_repotrt_img img {
            transition: 0.2s;
            transform: scale(1.1);
          }

          &:hover .p {
            background-size: 100% 4px !important;
          }
          .reports_list_current_text {
            overflow-y: auto;
            width: 320px;
            // height: 220px;
            // padding: 20px;
            word-wrap: break-word;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            // -webkit-line-clamp: 3;
            font-size: 31px;
            color: #fff;
            padding: 20px;

            color: #fff;
            font-size: 24px;
            font-weight: 600;
            // margin-bottom: 15px;
            z-index: 99;
            background: rgba(75, 159, 58, 1);
            .p {
              background-image: linear-gradient(#fff, #fff);
              background-position: left bottom;
              background-repeat: no-repeat;
              word-wrap: break-word;
              font-size: 26px;
              line-height: 38px;
              color: #fff;
              font-weight: 600;
              transition: background-size 0.2s
                cubic-bezier(0.55, 0.085, 0.68, 0.53);
              text-decoration: none;
              background-size: 0px 2px;
            }
            .reports_list_current_text_con {
              font-size: 18px;
              color: #fff;
              margin-top: 20px;
            }
          }
          .reports_list_current_repotrt {
            flex: 1;
            padding: 0px 30px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            padding-top: 10px;
            background: #fff;
            .reports_list_current_repotrt_img {
              width: 100%;
              height: 100%;
              overflow: hidden;
              position: relative;
              &::after {
                box-sizing: border-box;
                word-wrap: break-word;
                content: "";
                opacity: 0;
                background-image: linear-gradient(to bottom, transparent, #000);
                transition: opacity 0.3s cubic-bezier(0.55, 0.085, 0.68, 0.53);
                position: absolute;
                left: 0;
                top: 0;
                width: 100%;
                height: 100%;
              }
              &::before {
                content: "";
                display: block;
              }
              img {
                border-radius: 4px;
                transition: 0.8s ease;
                cursor: pointer;
                object-fit: cover;
                width: 100%;
                height: 100%;
              }
            }

            .download {
              min-height: 50px;
              display: flex;
              align-items: center;
              div {
                border-bottom: 4px solid #ccc;
                // background: rgba(226, 226, 226, 0.5);
                display: flex;
                // height: px;
                align-items: center;
                // border-radius: 3px;
                margin: 0 2px 6px;
                // height: 22px;
                color: #000;
                cursor: pointer;
                padding: 2px 10px;
                font-weight: 600;
                font-size: 14px;
                a {
                  color: #000;
                  &:hover {
                    color: #4b9f3a;
                  }
                }
              }
            }
          }
        }
      }
      .other_reports_list {
        width: 100%;
        height: 220px;
        background: rgba(0, 104, 157, 1);
      }
    }
  }
}
</style>